module.exports = __webpack_public_path__ + "img/upload-img.29a8e657.png";